<template>
    <div>
        <!-- <div v-if="serieApplied" class="alert alert-success d-flex align-items-center" role="alert">
            <div class="flex-shrink-0">
                <i class="fa fa-fw fa-check"></i>
            </div>
            <div class="flex-grow-1 ms-3">
                <p class="mb-0">
                    Abonnement appliqué ! : <b>{{ serieApplied.name }}</b>
                </p>
            </div>
        </div>
        <div v-if="treatmentApplied" class="alert alert-success d-flex align-items-center" role="alert">
            <div class="flex-shrink-0">
                <i class="fa fa-fw fa-check"></i>
            </div>
            <div class="flex-grow-1 ms-3">
                <p class="mb-0">
                    Cure appliquée ! : <b>{{ treatmentApplied.name }}</b>
                </p>
            </div>
        </div> -->
        <!-- dj -->
        <div v-if="showAlertPrepaid" class="alert alert-danger d-flex align-items-center" role="alert">
            <div class="flex-shrink-0">
                <i class="fa fa-fw fa-info"></i>
            </div>
            <div class="flex-grow-1 ms-3">
                <p class="mb-0">
                    Veuillez sélectionner le prépaiement à appliquer.
                </p>
            </div>
        </div>
        <div v-if="isClotured" class="alert alert-danger d-flex align-items-center" role="alert">
            <div class="flex-shrink-0">
                <i class="fa fa-fw fa-info"></i>
            </div>
            <div class="flex-grow-1 ms-3">
                <p class="mb-0">
                    Cette vente est cloturée
                </p>
            </div>
        </div>
        <div class="block shadow-sm rounded">
            <div class="block-header">
                <h3 class="block-title">
                    <i class="fa fa-fw fa-shopping-cart text-muted me-1 text-yellow"></i>
                    Panier ({{ Object.keys(c_cartItems).length }})
                </h3>
            </div>

            <div class="block-content overflow-auto pb-3" style="max-height: 100%;">
                <table class="table table-borderless table-hover table-vcenter">
                    <tbody v-if="Object.keys(c_cartItems).length > 0">
                        <tr v-for="item in c_cartItems" :key="item.id" id="articles_id" class="rounded">
                            <td>
                                <a
                                    v-if="!item.bookingId"
                                    style="margin-right: 10px"
                                    class="text-muted"
                                    :href="`/back-office/caisse/${item.rowId}/delete`"
                                    ><i class="fa fa-times"></i
                                ></a>
                                <a v-else><i class="fa fa-lock"></i></a>
                            </td>
                            <td>
                                <div class="d-flex align-center">
                                    <div class="h6" style="margin-bottom: 0px">{{ item.qty }} x {{ item.name }}</div>

                                    <template v-if="item.voucherCode">
                                        <v-icon small style="margin-left: 20px; margin-right: 5px">mdi-gift</v-icon
                                        >{{ item.voucherCode }}
                                        <div v-if="item.voucherCode" class="h6" style="margin-left: 20px;"></div>
                                    </template>

                                    <div class="d-flex">
                                        <span v-if="item.options.serie" class="text-success d-block d-inline">Abonnement</span>
                                        <span v-if="item.options.treatment" class="text-warning d-block d-inline">Cure</span>
                                    </div>
                                </div>
                                <div v-if="item">
                                    <b class="seller">
                                        <button
                                            class="ms-2"
                                            type="button"
                                            @click="openStaffModal(item.id, item.advised.id, item.seller.id)"
                                        >
                                            <span style="margin-right: 5px">
                                                <i class="far fa-address-book text-primary"></i>
                                                <span v-if="item.seller">{{ item.seller.first_name }}</span>
                                                <span v-else>{{ '@n/a' }}</span>
                                            </span>
                                            <span>
                                                <i class="far fa-comment-dots text-primary"></i>
                                                <span v-if="item.advised">{{ item.advised.first_name }}</span>
                                                <span v-else>{{ '@n/a' }}</span>
                                            </span>
                                        </button>
                                    </b>
                                    <div v-if="item.code" class="d-flex" style="flex-wrap: wrap">
                                        <div class="mt-2 mx-1" v-for="(val, index) of item.code" :key="index">
                                            <v-chip
                                                @click="
                                                    () => {
                                                        val.enable = !val.enable
                                                    }
                                                "
                                                color="red"
                                                label
                                                text-color="white"
                                                dense
                                                active
                                                style="height: 25px; cursor: pointer"
                                                :set="
                                                    (noComplete =
                                                        c_promoCodeNoCompleteUsed &&
                                                        c_promoCodeNoCompleteUsed.find(
                                                            x => x.codeId == val.id && item.rowId == x.itemKey
                                                        ))
                                                "
                                            >
                                                <v-icon left small>
                                                    mdi-ticket-percent
                                                </v-icon>
                                                <span
                                                    :style="val.enable ? '' : 'text-decoration: line-through'"
                                                    v-if="noComplete"
                                                >
                                                    {{ val.title }} --
                                                    {{ noComplete.used.toFixed(2) }}
                                                    /
                                                    {{ noComplete.amount.toFixed(2) }}
                                                    €
                                                </span>
                                                <span v-else :style="val.enable ? '' : 'text-decoration: line-through'">
                                                 {{ val.title }} -- {{ val.amount }}
                                                </span>
                                            </v-chip>
                                        </div>
                                    </div>
                                </div>
                            </td>
                            <td class="text-end">
                                <div class="d-flex align-items-center fw-semibold" style="justify-content: flex-end">
                                    <span
                                        style="text-decoration: line-through;"
                                        v-if="item._oldPrice && item._oldPrice != item.price"
                                        >{{ item._oldPrice }}€</span
                                    >
                                    <span class="ms-2 text-primary">{{ item.price.toFixed(2) }}€</span>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                    <tbody v-else>
                        <tr>
                            <td class="text-center text-gray-dark" colspan="6">
                                <span>Aucun article dans le panier.</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <h3 class="h6 block-title border-bottom ps-0 mt-1">
                    <i class="ml-1 fa fa-fw fa-money-bill text-muted me-1"></i>
                    Paiement
                </h3>
                <div class="bg-body-light d-flex justify-content-between align-content-center rounded mt-3">
                    <div class="d-flex flex-column w-100" style="flex: 1">
                        <v-simple-table>
                            <template v-slot:default>
                                <tbody >
                                    <!-- Total panier -->
                                    <tr style="border-bottom: 2px solid grey !important">
                                        <td class="h6">Montant du panier :</td>
                                        <td class="h6" style="text-align: right">
                                            {{ Math.round((c_remainAfterGlobalPromoCode + Number.EPSILON) * 100) / 100 }} €
                                        </td>
                                    </tr>

                                    <!-- Payment -->
                                    <template v-for="(val, index) of c_payments">
                                        <tr :key="index" v-if="val && parseFloat(val.value)">
                                            <td style="">{{ val.name }}</td>
                                            <td style="text-align: right; color: #6366F1; font-weight: bold">
                                                {{ val.value }} €
                                            </td>
                                        </tr>
                                    </template>

                                    <!-- Accompte -->
                                    <tr v-if="c_order && c_order.invoices && c_order.invoices.length">
                                        <td style="">Accompte</td>
                                        <td style="text-align: right; color: #6366F1; font-weight: bold;white-space: nowrap">
                                            {{ c_order.invoices.reduce((prev, current) => prev + current.amount, 0).toFixed(2) }} €
                                        </td>
                                    </tr>

                                    <!-- Point de fidelité -->
                                    <tr v-if="usedFidelityPoints">
                                        <td style="">Remise fidelité ({{ usedFidelityPoints }} pts)</td>
                                        <td style="text-align: right; color: #6366F1; font-weight: bold;white-space: nowrap">
                                            {{ usedFidelityPoints / c_establishment.points_for_one_euro }} €
                                        </td>
                                    </tr>

                                    <!-- Reste -->
                                    <tr style="border-top: 2px solid grey !important">
                                        <td
                                            class="h6"
                                            :class="[
                                                c_remainPrice > 0
                                                    ? 'text-danger'
                                                    : c_remainPrice < 0
                                                    ? 'text-warning'
                                                    : 'text-success',
                                            ]"
                                        >
                                            Reste dû :
                                        </td>
                                        <td
                                            class="h6"
                                            style="text-align: right"
                                            :class="[
                                                c_remainPrice > 0
                                                    ? 'text-danger'
                                                    : c_remainPrice < 0
                                                    ? 'text-warning'
                                                    : 'text-success',
                                            ]"
                                        >
                                            {{ c_remainPrice && c_remainPrice.includes('-0.00') ? '0.00' : c_remainPrice }} €
                                        </td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>

                        <div
                            v-if="accompte != 0"
                            class="block-content block-content-full bg-white rounded mb-2 d-flex flex-column w-100"
                        >
                            <span class="h6 fw-medium my-auto mb-1">Accompte et reste</span>
                            <span v-if="totalAccompte != 0" class="text-warning fw-bold my-auto"
                                >Accompte à payer : {{ totalAccompte }} €</span
                            >
                            <span v-if="rest != 0" class="text-success fw-bold my-auto">
                                Déjà payé :
                                {{ parseFloat(rest).toFixed(2) }}
                                €
                            </span>
                            <span v-if="rest != 0" class="text-success fw-bold my-auto">Déjà payé : {{ rest }} €</span>
                            <span v-if="rest != 0" class="text-primary fw-bold my-auto">
                                Reste à payer :
                                {{ parseFloat(totalWRest).toFixed(2) }}
                                €
                            </span>
                            <span v-if="rest != 0" class="text-primary fw-bold my-auto">Reste à payer : {{ totalWRest }} €</span>
                        </div>
                    </div>
                </div>

                <input
                    v-for="(val, index) of c_voucherUsed"
                    type="hidden"
                    name="voucher-used[]"
                    :value="stringify(val)"
                    :key="index"
                />

                <input
                    v-for="(val, index) of prepaidTreatment"
                    type="hidden"
                    name="prepaid-treatment[]"
                    :key="'p' + index"
                    :value="stringify(val)"
                />
                <input
                    v-for="(val, index) of prepaidSerie"
                    type="hidden"
                    name="prepaid-serie[]"
                    :key="'p' + index"
                    :value="stringify(val)"
                />
                <h3 class="h6 block-title border-bottom ps-0 mt-3 mb-3">
                    <i class="ml-1 fas fa-coins text-muted me-1"></i>
                    Point(s) de fidélité
                </h3>
                <div
                    v-if="c_customer && c_customer.customer.loyalty_points !== undefined"
                    class="block-content block-content-full bg-body-light d-flex justify-content-between align-content-center rounded"
                >
                    <div class="d-flex flex-column w-100">
                        <div class="d-flex">
                            <input
                                type="number"
                                class="form-control disable-focus"
                                style="border-radius: 24px 0 0 24px;"
                                name="fidelity_points"
                                id="fidelity_points"
                                min="0"
                                :max="`${maxFidelityPoint}`"
                                step="1"
                                @input="
                                    val => {
                                        if (parseInt(usedFidelityPoints) > maxFidelityPoint)
                                            usedFidelityPoints = `${maxFidelityPoint}`
                                    }
                                "
                                v-model="usedFidelityPoints"
                            />
                            <div style="border-radius: 0 24px 24px 0 !important;" class="text-primary bg-primary-lighter p-2 fw-bold px-3">
                                {{ usedFidelityPoints / c_establishment.points_for_one_euro }}€
                            </div>
                        </div>
                        <div class="text-success">
                            Point(s) restant(s) :
                            <b>{{ c_customer.customer.loyalty_points - (usedFidelityPoints || 0) }}</b>
                            <i class="fas fa-coins"></i>
                        </div>
                    </div>
                </div>

                <h3 class="h6 block-title border-bottom ps-0 mt-3 mb-3">
                    <i class="ml-1 si si-settings text-muted me-1"></i>
                    Options
                </h3>

                <div v-if="sendInvoice" id="container_company" class="form-group mt-3 mb-3 mx-3">
                    <label class="form-label" for="company_name">Ajouter une société sur la facture</label>
                    <input class="form-control" type="text" name="company_name" id="company_name" v-model="company_name" />
                    <div class="d-flex gap-2 w-100 mt-3">
                        <div class="w-100">
                            <label class="form-label" for="company_address">Adresse</label>
                            <input
                                class="form-control"
                                type="text"
                                name="company_address"
                                id="company_address"
                                ref="company_address"
                                v-model="company_address.address"
                            />
                        </div>
                        <div class="w-100">
                            <label class="form-label" for="company_cp">Code postal</label>
                            <input
                                class="form-control"
                                type="text"
                                name="company_cp"
                                id="company_cp"
                                ref="company_cp"
                                v-model="company_address.cp"
                            />
                        </div>
                        <div class="w-100">
                            <label class="form-label" for="company_country">Pays</label>
                            <input
                                class="form-control"
                                type="text"
                                name="company_country"
                                id="company_country"
                                ref="company_country"
                                v-model="company_address.country"
                            />
                        </div>
                    </div>
                </div>
                <div v-else>
                    <input type="hidden" name="company_name" :value="company_name" />
                    <input type="hidden" name="company_address" :value="company_address.address" />
                    <input type="hidden" name="company_cp" :value="company_address.cp" />
                    <input type="hidden" name="company_country" :value="company_address.country" />
                </div>

                <div v-if="sendMail" class="mb-2">
                    <label class="form-label">Mail de remerciement</label>
                    <div class="form-check">
                        <input
                            id="rebooking"
                            class="form-check-input"
                            type="checkbox"
                            @change="
                                event => {
                                    parameterThanks.rebooking = event.target.checked
                                }
                            "
                        />
                        <label for="rebooking" class="form-label">Offre de rebooking</label>
                    </div>
                    <div class="form-check">
                        <input
                            id="notice"
                            class="form-check-input"
                            type="checkbox"
                            @change="
                                event => {
                                    parameterThanks.notice = event.target.checked
                                }
                            "
                        />
                        <label for="notice" class="form-label">Liens des avis</label>
                    </div>
                </div>
                <div class="d-flex justify-content-around align-items-center flex-shrink-0 flex-wrap">
                    <div class="form-switch p-0">
                        <input type="hidden" id="close_sale" name="close_sale" :value="closeSale" />
                        <button
                            type="button"
                            role="button"
                            class="btn btn-sm rounded-pill"
                            :disabled="c_remainPrice != 0"
                            :class="[c_remainPrice > 0 ? 'btn-danger' : c_remainPrice < 0 ? 'btn-warning' : 'btn-yellow']"

                            @click="
                                () => {
                                    closeSale = !closeSale
                                }
                            "
                            ref="closeSaleBtn"
                        >
                            <i
                                class="fa fa-xs fa-fw fa-check me-2"
                                :class="closeSale ? 'd-inline-block' : 'd-none'"
                                ref="closeSaleIcon"
                            ></i


                            >Cloturer la vente


                        </button>
                    </div>
                    <div class="form-switch p-0">
                        <input type="hidden" name="parameterThanksMail" :value="JSON.stringify(parameterThanks)" />
                        <input v-if="sendMail" type="hidden" id="send_mail" name="send_mail" :value="sendMail" />
                        <button
                            type="button"
                            role="button"
                            class="btn btn-sm rounded-pill"
                            :class="sendMail ? 'btn-info text-white' : 'btn-outline-info'"
                            @click="
                                () => {
                                    sendMail = !sendMail
                                    if(!sendMail) {
                                        parameterThanks = {
                                            rebooking: null,
                                            notice: null
                                        }
                                    }
                                }
                            "
                            ref="sendMailBtn"
                        >
                            <i
                                class="fa fa-xs fa-fw fa-check pe-2"
                                :class="sendMail ? 'd-inline-block' : 'd-none'"
                                ref="sendMailIcon"
                            ></i
                            >Mail de remerciement
                        </button>
                    </div>
                    <div class="form-switch p-0">
                        <input v-if="sendInvoice" type="hidden" id="send_invoice" name="send_invoice" :value="sendInvoice" />
                        <button
                            type="button"
                            role="button"
                            class="btn btn-sm rounded-pill"
                            :class="sendInvoice ? 'btn-warning text-white' : 'btn-outline-warning'"
                            @click="
                                () => {
                                    sendInvoice = !sendInvoice
                                    if(!sendInvoice) {
                                        company_name = null
                                        company_address = {
                                            address: null,
                                            cp: null,
                                            country: null
                                        }
                                    }
                                }
                            "
                            ref="sendInvoiceBtn"
                        >
                            <i
                                class="fa fa-xs fa-fw fa-check pe-2"
                                :class="sendInvoice ? 'd-inline-block' : 'd-none'"
                                ref="sendInvoiceIcon"
                            ></i
                            >Facture
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="alert alert-warning alert-dismissible" role="alert" v-if="c_remainPrice < 0">
            <p class="mb-0">
                Attention, vous allez encaisser plus d'argent que la valeur du panier.
            </p>
        </div>

        <div class="d-flex justify-content-center mt-3 align-items-center w-100">
            <input type="hidden" id="order_id" name="order_id" :value="orderId" />
            <div class="form-switch p-0">
                <button
                    id="cashIn"
                    class="btn text-light px-4 py-2 rounded-pill"
                    :class="[c_remainPrice > 0 ? 'btn-danger' : c_remainPrice < 0 ? 'btn-warning' : 'btn-primary']"
                    @click="submitForm()"
                    type="button"
                >
                    Encaisser
                </button>
            </div>
        </div>

        <!-- Affichage des acomptes -->
        <div v-if="c_order && c_order.invoices.length > 0" class="px-2">
            <h3 class="h6 block-title border-bottom ps-0 mt-4 mb-3">
                <i class="text-primary fa fa-fw fa-money-bill-wave text-muted me-1"></i>
                Déjà payé
            </h3>
            <table class="table table-striped table-vcenter table-bordered">
                <thead>
                    <tr>
                        <th>Date</th>
                        <th>Type</th>
                        <th>Montant</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in invoices" :key="index">
                        <td>{{ parseDate(item.updated_at, 'lll') }}</td>
                        <td>
                            <span class="badge bg-primary rounded-pill">{{ item.payment_method.name }}</span>
                            <br />
                            <span v-if="item.voucher_id">({{ item.voucher }})</span>
                        </td>
                        <td>{{ parseFloat(item.amount).toFixed(2) }}€</td>
                        <td v-if="item.amount > 0">
                            <PaymentRefound :item="item"></PaymentRefound>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <!-- Affichage de la sécurisation -->
        <div v-if="c_order && c_order.fingerprints.length > 0" class="px-2">
            <h3 class="h6 block-title border-bottom ps-0 mt-4 mb-3">
                <i class="text-primary fa fa-fw fa-money-bill-wave text-muted me-1"></i>
                Sécurisation
            </h3>
            <table class="table table-striped table-vcenter table-bordered">
                <thead>
                    <tr>
                        <th>Date</th>
                        <th>Type</th>
                        <th>Montant</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in c_order.fingerprints" :key="index">
                        <td>{{ parseDate(item.updated_at, 'lll') }}</td>
                        <td>
                            <span class="badge bg-primary rounded-pill" v-if="item.stripe_id">stripe</span>
                            <span class="badge bg-primary rounded-pill" v-if="item.voucher_id">Bon cadeau</span>
                            <span class="badge bg-primary rounded-pill" v-if="item.serie_user_id">Abonnement</span>
                            <span class="badge bg-primary rounded-pill" v-if="item.treatment_user_id">Cure</span>
                            <br />
                            <span v-if="item.voucher_id">( {{ item.voucherCode }} )</span>
                        </td>
                        <td>{{ parseFloat(item.amount).toFixed(2) }}€</td>
                        <td v-if="item.amount > 0">
                            <FingerprintChange :item="item"></FingerprintChange>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div :class="Object.values(staffModalData).every(s => s !== null) ? 'd-block' : 'd-none'">
            <staff-modal
                v-if="staffModalData.cartRowId && staffModalData.adviserId && staffModalData.sellerId"
                :cartRowId="staffModalData.cartRowId"
                :adviserId="staffModalData.adviserId"
                :sellerId="staffModalData.sellerId"
                @hide-staff-modal="hideStaffModal"
            ></staff-modal>
        </div>
        <close-sale-modal
            v-if="showModalCloseSale"
            :closeSaleModal="showModalCloseSale"
            :companyName="company_name"
            :companyAddress="company_address"
            :parameterThanks="parameterThanks"
            :sendInvoice="sendInvoice"
            :sendMail="sendMail"
            @close-sale="hideCloseSaleModal"
            @close-sale-modal="closeSaleModal"
        ></close-sale-modal>
    </div>
</template>

<script>
import moment from 'moment'
import { sync, get } from 'vuex-pathify'
import StaffModal from './StaffModal.vue'
import PaymentRefound from './PaymentRefound.vue'
import FingerprintChange from './FingerprintChange.vue'
import axios from 'axios'
import CloseSaleModal from './CloseSaleModal.vue'

export default {
    components: { StaffModal, PaymentRefound, FingerprintChange, CloseSaleModal },
    props: [
        'accompte',
        'rest',
        'totalAccompte',
        'totalWithDiscount',
        'cartTotal',
        'promoCode',
        'saveBasketRoute',
        'orderId',
        'isClotured',
        'orderObj',
    ],
    data: () => ({
        closeSale: false,
        showModalThanks: false,
        showModalCloseSale: false,
        usedFidelityPoints: 0,
        isPrepaid: false,
        staffModalData: { cartRowId: null, adviserId: null, sellerId: null },
        parameterThanks: {
            rebooking: false,
            notice: false,
        },
        invoices: [],
        company_name: null,
        company_address: {
            address: null,
            cp: null,
            country: null,
        },
        sendInvoice: false,
        sendMail: false
    }),
    created() {
        this.sendInvoice = this.orderObj && this.orderObj.send_invoice
        this.sendMail = false
        this.company_name = this.orderObj && this.orderObj.company_name
        if (this.orderObj && this.orderObj.company_address) {
            const full_address = this.orderObj.company_address.split('_')
            this.company_address.address = full_address[0]
            this.company_address.cp = full_address[1]
            this.company_address.country = full_address[2]
        }
    },
    computed: {
        ...get('overlay@data', {
            c_remainPrice: 'remainPrice',
            c_payments: 'payments',
            c_customer: 'customer',
            c_establishment: 'establishment',
            c_prepaidPrestations: 'prepaidPrestations',
            c_promoCodes: 'promoCodes',
            c_customDiscount: 'customDiscount',
            c_order: 'order',
            c_remainBeforeGlobalPromoCode: 'remainBeforeGlobalPromoCode',
            c_remainAfterGlobalPromoCode: 'remainAfterGlobalPromoCode',
            c_promoCodeNoCompleteUsed: 'promoCodeNoCompleteUsed',
            c_voucherUsed: 'voucherUsed',
        }),
        ...sync('overlay@data', {
            c_cartItems: 'cartItems',
            c_promoCodes: 'promoCodes',
        }),
        maxFidelityPoint() {
            return this.c_customer.customer.loyalty_points
        },
        showAlertPrepaid() {
            var isPrepaid = false
            var isPrepaidApplied = false
            if (this.c_cartItems && this.c_prepaidPrestations) {
                const serieItems = Object.values(this.c_cartItems).filter(x => x.options.serie)
                const treatmentItems = Object.values(this.c_cartItems).filter(x => x.options.treatment)

                if (serieItems.length > 0 || treatmentItems.length > 0) {
                    this.isPrepaid = true
                    return true
                }
                if (this.c_prepaidPrestations.length > 0) {
                    isPrepaidApplied = true
                } else {
                    isPrepaidApplied = false
                }

                if (this.isPrepaid && isPrepaidApplied) {
                    return false
                }
            }

            return false
        },
        prepaidTreatment() {
            if (this.c_prepaidPrestations)
                return this.c_prepaidPrestations
                    .filter(x => x.prepaid.type == 'treatment')
                    .map(x => {
                        return {
                            orderItem: x.prestation.id,
                            userTreatment: x.prepaid.pivot.id,
                        }
                    })
        },
        prepaidSerie() {
            if (this.c_prepaidPrestations)
                return this.c_prepaidPrestations
                    .filter(x => x.prepaid.type == 'serie')
                    .map(x => {
                        return {
                            orderItem: x.prestation.id,
                            userSerie: x.prepaid.pivot.id,
                        }
                    })
        },
    },
    methods: {
        console() {
            return console
        },
        getVoucherCode(id) {
            return axios.get(`/back-office/caisse/getVoucherCode/${id}`).then(res => res.data)
        },
        stringify(val) {
            return JSON.stringify(val)
        },
        parseDate(date, format) {
            return moment(date)
                .locale('fr')
                .format(format)
        },
        getValueOfDate(date) {
            return moment(date).valueOf()
        },
        totalAmountGlobalRemise(codes) {
            let price = parseFloat(this.c_remainBeforeGlobalPromoCode).toFixed(2)
            const old = price
            if (codes && codes.find(x => x.is_global||x.is_voucher)) {
                codes.forEach(t => {
                    if (!t.is_global||!t.is_voucher) return

                    price -= this._computeAmountCodePromo(price, t)
                })
            }
            return { old: old, new: price }
        },
        _computeAmountCodePromo(amount, currentCode) {
            let res = 0
            if (currentCode.discount_type == 'fixed') {
                res = amount > currentCode.discount_amount ? currentCode.discount_amount : amount
            } else if (currentCode.discount_type == 'percentage') {
                res = amount * (currentCode.discount_amount / 100)
            }
            return res
        },
        submitForm() {
            if (this.c_remainPrice == 0 && this.closeSale == false) {
                //this.closeSale = true
                this.showModalCloseSale = true
            } else {
                this.$emit('submit-form')
            }
        },
        openStaffModal(cartRowId, adviserId, sellerId) {
            this.staffModalData = {
                cartRowId: cartRowId,
                adviserId: adviserId,
                sellerId: sellerId,
            }
        },
        hideStaffModal() {
            Object.keys(this.staffModalData).forEach(key => {
                this.staffModalData[key] = null
            })
        },
        hideCloseSaleModal(data) {
            this.closeSale = data.close_sale
            this.company_name = data.company_name
            this.company_address = data.company_address
            this.parameterThanks.rebooking = data.rebooking
            this.parameterThanks.notice = data.notice
            this.showModalCloseSale = false
            this.sendMail = data.send_mail
            this.sendInvoice = data.send_invoice

            setTimeout(() => {
                this.$emit('submit-form')
            }, 300)
        },
        closeSaleModal() {
            this.closeSale = false
            this.showModalCloseSale = false
        },
    },
    watch: {
        c_remainPrice(val) {
            if (this.closeSale && val !== '0.00') {
                this.closeSale = false
            }
        },
        usedFidelityPoints(newVal) {
            this.$emit('used-fidelity-points', newVal)
        },

        async 'c_order.invoices'(val) {
            if (!val) return

            const copy = []
            for (let i = 0; i < val.length; i++) {
                const elem = val[i]
                if (elem.voucher_id) elem.voucher = await this.getVoucherCode(elem.voucher_id)
                copy.push(elem)
            }
            this.invoices = copy.reverse()
        },
        // sendInvoice(newVal) {
        //     if(newVal == false) {
        //         this.company_name = null
        //         this.company_address = {
        //             address: null,
        //             cp: null,
        //             country: null,
        //         }
        //     }
        // },
        // sendMail(newVal) {
        //     if(newVal == false) {
        //         this.parameterThanks = {
        //             rebooking: false,
        //             notice: false,
        //         }
        //     }
        // }
    },
}
</script>

<style>
.disable-focus:focus {
    border-color: none !important;
    box-shadow: none !important;
}
</style>
